import React from 'react';
import { Utils } from '../../services';
import SelectField from '../SelectField/SelectField';
import MultiSelectField from '../MultiSelectField/MultiSelectField';
import i18n from "i18next";

const FormsField = ({ forms, single, name }) => {

    const default_lang = Utils.default_lang();

    const options = forms.map((form) => ({
        key: form.id,
        text: form.name[i18n.language] ?? form.name[default_lang],
        value: form.id
    }));

    return single ? (
        <SelectField name={ name } options={ options } />
    ) : (
        <MultiSelectField name={ name } options={ options } />
    );
}

export default FormsField;
